import axios from 'axios'
import { RecordAltFind } from '@core/js/helpers/functions'

const state = {
  billingAddress: {
    payer_type: 1,
    vat_no: '',
    firstname: '',
    lastname: '',
    is_company: true,
    company_name: '',
    company_code: '',
    phone: '',
    email: '',
    address: '',
    address_two: '',
    city: '',
    county: '',
    country: '',
    country_name: '',
    country_code: '',
    zip: ''
  },
  paymentMethod: {
    type_id: 1,
    payment_method: 'neopay',
    payment_fee: 0,
    sub_type_id: ''
  },
  notes: '',
  total: 0,
  tax: 0,
  expire_date: '',
  isLoading: false,
  terms_agreed: false
}

const getters = {
  billingAddressComplete(state, value) {
    var required = [
      'payer_type',
      'firstname',
      'lastname',
      'phone',
      'address',
      'city',
      'country'
    ]
    var emptyFields = required.filter(input => {
      return state.billingAddress[input] === ''
    }).length

    return emptyFields === 0
  },
  getData(state, value) {
    return state
  },
  getIsLoading(state, value) {
    return state.isLoading
  },
  getTotal(state, value) {
    return state.total
  }
}

const mutations = {
  setIsLoading(state, data) {
    state.isLoading = data
  }
}

const actions = {
  proceedCheckout({ commit, dispatch, state }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/checkout/process',
        data: {
          billingAddress: state.billingAddress,
          paymentMethod: state.paymentMethod,
          terms_agreed: state.terms_agreed ? 1 : 0
        }
      })
        .then(response => {
          commit('setIsLoading', false)
          resolve(response)
        })
        .catch(error => {
          commit('order/setShowErrors', true)
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            commit('order/setErrors', error.response.data.errors)
          }

          commit('setIsLoading', false)
          reject(error)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
